import { useNavigate } from 'react-router-dom'

import { Layout } from '@/modules/shared/layouts/layout'

import { SalesGoalInterface } from '../interfaces/sales-goals.interface'

export function SalesGoalContainer() {
  const navigate = useNavigate()

  const handleBackPage = () => {
    navigate('/relatorios')
  }

  return (
    <Layout hasSellerFilter
      pageTitle="Relatório - Metas de Vendas"
      handleGoBack={handleBackPage}
    >
      <SalesGoalInterface />
    </Layout>
  )
}
